import { Activity } from '../models/activity';
import { Customer } from '../models/customer';
import { DeliveryRequest } from '../models/deliveryRequest';
import { Department } from '../models/department';
import { Device } from '../models/device';
import { EmailNew } from '../models/EmailNew';
import { MetaDataAT } from '../models/metaDataConfig';
import { ReceivingDelivery } from '../models/ReceivingDelivery';
import { RejectionComment } from '../models/RejectionComment';
import { RolesAndPermissionsID, Roles } from '../models/rolesAndPermissions';
import { shelfRack } from '../models/shelfRack';
import { AssetType } from '../models/template';

import { Vault } from '../models/vault';
import { WorkLevel } from '../models/workLevel';
import { store } from './store';

export function ClearAllStore() {
  store.activityStore.activityRegistry = new Map<string, Activity>();
  store.emailStore.emailRegistry = new Map<string, EmailNew>();
  store.receivingdeliveryStore.receivingdeliveryRegistry = new Map<
    string,
    ReceivingDelivery
  >();
  store.customerStore.customerRegistery = new Map<string, Customer>();
  // store.DeliveryStore.deliveryRequestRegistry = new Map<
  //   string,
  //   DeliveryRequest
  // >();
  store.DeliveryStore.allDeliveryRequestRegistry = new Map<
    string,
    DeliveryRequest
  >();
  store.departmentStore.departmentRegistry = new Map<string, Department>();
  store.DeviceStore.deviceRegistry = new Map<string, Device>();
  store.metaDataStore.metaDataATRegistry = new Map<string, MetaDataAT>();
  store.rejectionStore.rejectionRegistry = new Map<string, RejectionComment>();
  store.RolesAndPermissionsIDStore.rolesIDRegistry = new Map<
    string,
    RolesAndPermissionsID
  >();
  store.RolesAndPermissionsStore.rolesRegistry = new Map<string, Roles>();
  store.ShelfRackStore.shelfRackRegistry = new Map<string, shelfRack>();
  store.TemplateStore.assetTypeRegistry = new Map<string, AssetType>();
  store.vaultStore.vaultRegistry = new Map<string, Vault>();
  store.WorkLevelStore.workLevelRegistry = new Map<string, WorkLevel>();

  store.dashboardStore.resetDashboard();
  store.mediaAssetStore.resetMediaAsset();
  store.workflowConfigurationStore.resetWorkflowConfigurationStore();

  store.commonStore.hfcCustomerChanges = false;
}
